import { useState } from "react";

type ModelActionType = "delete" | "add" | "alert";

type PageActions = {
  showAddModel: boolean;
  showDeleteModel: boolean;
  showAlertModel: boolean;
};

export const usePageModels = () => {
  const [models, updateModelsState] = useState<PageActions>({
    showAddModel: false,
    showDeleteModel: false,
    showAlertModel: false,
  });


  const openModel = (action: ModelActionType) => {
    if (action === "add") {
        updateModelsState({
        showAddModel: true,
        showDeleteModel: false,
        showAlertModel: false,
      });
    } else if (action === "delete") {
        updateModelsState({
        showAddModel: false,
        showDeleteModel: true,
        showAlertModel: false,
      });
    } else if (action === "alert") {
        updateModelsState({
        showAddModel: false,
        showDeleteModel: false,
        showAlertModel: true,
      });
    }
  };
  function closeModel(){
    updateModelsState({showAddModel:false,showDeleteModel:false,showAlertModel:false})
  }
return {models,closeModel,openModel}
};


